// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".__picture_lazy,.__picture_lazy>img{height:100%;width:100%}.__picture_lazy>img{display:block}.__picture_lazy>img:not(.v-lazy-image-loaded){background-color:#ccc;border:1px solid #ccc;height:0;padding-top:calc(100%*var(--a))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
